import { AgmCoreModule } from "@agm/core";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { FormFieldStateModule } from "src/app/views/pages/mad_shared/form-field-state/form-field-state.module";
import { environment } from "src/environments/environment";
import { ComparableLocationComponent } from "./comparable-location/comparable-location.component";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from '@angular/material/select'
import { InspectionLocationComponent } from "./inspection-location/inspection-location.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,

        AgmCoreModule.forRoot({
            apiKey: environment.agMapKey,
            libraries: ['places']
        }),

        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,

        NgbPopoverModule,

        FormFieldStateModule,
    ],
    declarations: [
        ComparableLocationComponent,
        InspectionLocationComponent
    ],
    exports: [
        ComparableLocationComponent,
        InspectionLocationComponent
    ]
})
export class LocationModule {}